import React from 'react';

const teamShortName = (team) => {
  const color = (team?.color || '').toLowerCase();
  if (color === 'black') return 'Black';
  if (color === 'white') return 'White';
  return team?.name || '';
};

const playersForTeam = (match, teamId) =>
  (match.player_stats || []).filter((ps) => ps.team?.id === teamId);

const PlayerTable = ({ players, notPlayed }) => {
  if (notPlayed) {
    return <p className="match-details-empty">Match not played</p>;
  }
  if (players.length === 0) {
    return <p className="match-details-empty">No player stats</p>;
  }
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Player</th>
          <th>Goals</th>
          <th>Assists</th>
        </tr>
      </thead>
      <tbody>
        {players.map((ps) => (
          <tr key={ps.id || ps.player?.id}>
            <td>{ps.player?.name || '—'}</td>
            <td>{ps.goals}</td>
            <td>{ps.assists}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const MatchDetailsModal = ({ match, onClose }) => {
  const blackPlayers = playersForTeam(match, match.team1?.id);
  const whitePlayers = playersForTeam(match, match.team2?.id);
  const score = match.not_played
    ? 'Not played'
    : `${match.team1_score} – ${match.team2_score}`;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content match-details-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Match details</h2>
        <p className="match-details-meta">
          <strong>{match.date}</strong>
          {' · '}
          {teamShortName(match.team1)} {score} {teamShortName(match.team2)}
        </p>
        {match.funny_fact ? (
          <p className="match-details-fact">Fun fact: {match.funny_fact}</p>
        ) : null}

        <div className="match-details-teams">
          <section>
            <h3>{teamShortName(match.team1)}</h3>
            <PlayerTable players={blackPlayers} notPlayed={match.not_played} />
          </section>
          <section>
            <h3>{teamShortName(match.team2)}</h3>
            <PlayerTable players={whitePlayers} notPlayed={match.not_played} />
          </section>
        </div>

        <div className="modal-actions">
          <button className="btn btn-secondary" type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MatchDetailsModal;
